import { Pipe, PipeTransform, NgZone, ChangeDetectorRef, OnDestroy } from '@angular/core';
import * as moment from 'moment';
@Pipe({
    name: 'displayTime',
    pure: false
})
export class DisplayTimePipe implements PipeTransform {
    constructor() { }
    transform(value: string, format: string) {
        if (!value || !format) return '';
        moment.locale('en');
        return moment(value, 'hh:mm').format('hh:mm A')
    }
}
